import React, { Component } from "react";
import Error from "./Error";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

/*
Component de tipus HOC que serveix per capturar els errors que es donin al component especificat per paràmetre.
Es una aplicació de "ErrorBoundary" amb HOC.
*/
const errorBoundaryWrapper = ComposedComponent =>
  class extends Component {
    static displayName = `ErrorBoundaryWrapper(${getDisplayName(
      ComposedComponent
    )})`;

    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }

    componentDidCatch() {
      this.setState({ hasError: true });
    }

    render() {
      return this.state.hasError ? (
        <Error />
      ) : (
        <ComposedComponent {...this.props} />
      );
    }
  };

export default errorBoundaryWrapper;
